import React, { useCallback, useEffect, useState } from 'react';
import { Copy, Plus, RefreshCw, Search, Trash2 } from 'lucide-react';
import Loader from '../Loader';
import { Badge, Confirm, Empty, HScroll, Pager } from './UpUi';
import { date } from './format';

const STATES = { available: ['disponible', 'info'], used: ['utilisé', 'ok'], expired: ['expiré', 'muted'] }

/** Codes d'invitation du projet : création (codes de l'admin), liste filtrable, suppression des codes pas encore utilisés. */
const UpInvites = ({ pApi, onOpen, notify, reloadKey, onChanged }) => {
    const [page, setPage] = useState(1)
    const [state, setState] = useState('')
    const [search, setSearch] = useState('')
    const [q, setQ] = useState('')
    const [data, setData] = useState(null)
    const [error, setError] = useState('')
    const [count, setCount] = useState(5)
    const [days, setDays] = useState(0)
    const [created, setCreated] = useState([])
    const [confirm, setConfirm] = useState(null)

    const load = useCallback(async () => {
        setError('')
        try { setData(await pApi.get('/invites', { page, perPage: 25, ...(state && { state }), ...(q && { q }) })) } catch (e) { setError(e.message) }
    }, [pApi, page, state, q])
    useEffect(() => { load() }, [load, reloadKey])
    useEffect(() => {
        const t = setTimeout(() => { setQ(search.trim()); setPage(1) }, 350)
        return () => clearTimeout(t)
    }, [search])

    const create = async () => {
        try {
            const r = await pApi.post('/invites', { count: Number(count), days: Number(days) })
            setCreated(r.codes)
            notify(`${r.codes.length} code(s) créé(s)`)
            load()
            onChanged()
        } catch (e) { notify(e.message, true) }
    }
    const copy = (text) => navigator.clipboard?.writeText(text).then(() => notify('Copié'), () => notify('Copie impossible', true))
    const del = (c) => setConfirm({
        title: 'Supprimer ce code',
        text: `Supprimer ${c.code} ? Il ne pourra plus servir.`,
        action: 'Supprimer',
        danger: true,
        onConfirm: async () => {
            try { await pApi.del(`/invites/${c.id}`); notify('Code supprimé'); load(); onChanged() } catch (e) { notify(e.message, true) }
        },
    })

    return (
        <div>
            <div className='up-create'>
                <p className='up-subtitle'>Créer des codes</p>
                <div className='up-inline'>
                    <label className='up-label'>Nombre</label>
                    <input className='up-input sm' type='number' min='1' max='100' value={count} onChange={(e) => setCount(e.currentTarget.value)} />
                    <label className='up-label'>Validité (jours, 0 = sans fin)</label>
                    <input className='up-input sm' type='number' min='0' max='365' value={days} onChange={(e) => setDays(e.currentTarget.value)} />
                    <button className='btn cs' onClick={create}><Plus size={15} /> Créer</button>
                </div>
                {created.length > 0 && (
                    <div className='up-codes'>
                        {created.map((c) => <code key={c}>{c}</code>)}
                        <button className='btn cw' onClick={() => copy(created.join('\n'))}><Copy size={14} /> Tout copier</button>
                    </div>
                )}
            </div>

            <div className='up-toolbar'>
                <div className='up-search'>
                    <Search size={16} />
                    <input placeholder='Code ou email…' value={search} onChange={(e) => setSearch(e.currentTarget.value)} />
                </div>
                <select value={state} onChange={(e) => { setState(e.currentTarget.value); setPage(1) }}>
                    <option value=''>Tous les codes</option>
                    <option value='available'>Disponibles</option>
                    <option value='used'>Utilisés</option>
                    <option value='expired'>Expirés</option>
                </select>
                <button className='btn cw up-icon-btn' onClick={load} title='Actualiser'><RefreshCw size={15} /></button>
            </div>
            {error && <p className='up-error'>{error}</p>}
            {!data && !error ? <div className='up-loading'><Loader /></div> : data && (
                <>
                    <p className='up-count'><b>{data.total}</b> code{data.total > 1 ? 's' : ''}</p>
                    <HScroll>
                        <div className='up-table up-table-codes'>
                            <div className='up-thead'><span>Code</span><span>État</span><span>À qui</span><span>Utilisé par</span><span>Créé</span><span>Expire</span><span></span></div>
                            {data.items.map((c) => (
                                <div key={c.id} className='up-row static'>
                                    <span><code>{c.code}</code> <button className='up-copy' title='Copier' onClick={() => copy(c.code)}><Copy size={13} /></button></span>
                                    <span><Badge tone={STATES[c.state][1]}>{STATES[c.state][0]}</Badge></span>
                                    <span className='truncate'>{c.owner ? <button className='up-linkbtn' onClick={() => onOpen(c.owner.id)}>{c.owner.email}</button> : <span className='up-muted'>admin</span>}</span>
                                    <span className='truncate'>{c.usedBy ? <button className='up-linkbtn' onClick={() => onOpen(c.usedBy.id)}>{c.usedBy.email}</button> : '—'}{c.usedAt ? <small className='up-muted'> · {date(c.usedAt)}</small> : ''}</span>
                                    <span>{date(c.createdAt)}</span>
                                    <span>{c.expiresAt ? date(c.expiresAt) : <span className='up-muted'>sans fin</span>}</span>
                                    <span className='tar'>
                                        {!c.usedById && <button className='pay-act-btn' title='Supprimer' onClick={() => del(c)}><Trash2 size={15} color='#f71717' /></button>}
                                    </span>
                                </div>
                            ))}
                            {!data.items.length && <Empty>Aucun code</Empty>}
                        </div>
                    </HScroll>
                    <Pager page={data.page} pages={data.pages} onPage={setPage} />
                </>
            )}
            {confirm && <Confirm {...confirm} onClose={() => setConfirm(null)} />}
        </div>
    )
}

export default UpInvites;
